module.exports = __webpack_public_path__ + "img/01841_06_mobile.e15498cd.png";